<template>
  <div class="a-accordion__collapse ">
    <div class="a-container-form">
      <div class="table-tab__container" tabindex="1" style="overflow: hidden; outline: none;">
        <table class="table-tab__block table " style="width: 1200px">
          <thead class="table-tab__thead">
          <tr class="table-tab__height-auto-column-header" style="height: 48px;">
            <th>Номер задания</th>
            <th>Номер лота</th>
            <th>Дата задания</th>
            <th>Доступность</th>
            <th>Организатор</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
            <tr class="table-tab__tr-border" v-for="item in records">
              <td>
                <input type="text"
                       class="a-input a-input--w-380"
                       v-model="item.numTask"
                       v-if="item.editable">
                <span v-else>
                  {{item.numTask}}
                </span>
              </td>
              <td>
                <input type="text"
                       class="a-input a-input--w-380"
                       v-model="item.num"
                       v-if="item.editable">
                <span v-else>
                  <span v-if="!item.lotId">
                  {{item.num}}
                  </span>
                  <router-link v-else
                    class="table-tab__color"
                    :to="{
                      name: 'purchases-lot-details',
                      params: {
                        lotId: item.lotId,
                        tab: 'overview'
                      }
                    }">
                    {{item.num}}
                  </router-link>
                </span>
              </td>
              <td>
                <template v-if="item.editable">
                  <div class="a-input-group ">
                    <div class="a-input-group__prepend ">
                      <img src="@/assets/img/static/vector.svg" alt="">
                    </div>
                    <date-picker v-model="item.time"></date-picker>
                  </div>
                </template>
                <date-time class="a-input a-input--disabled"
                           :value="item.time"
                           :time="false"
                           v-else>
                </date-time>
              </td>
              <td>
                <span v-if="item.used">Использован</span>
                <span v-else>Доступен</span>
              </td>
              <td>
                <span v-if="item.used">{{item | fullName}}</span>
              </td>
              <td>
                <template v-if="item.editable">
                  <div class="a-width-auto">
                    <button class="a-accordion__ok-btn" type="button" @click="onConfirmClick(item)">
                      <img src="@/assets/img/static/tab-ok.svg">
                    </button>
                    <button class="a-accordion__clear-btn" type="button" @click="onCancelClick(item)">
                      <img src="@/assets/img/static/tab-close.svg">
                    </button>
                  </div>
                </template>
                <template v-else-if="!item.used">
                  <div class="a-width-auto">
                    <button class="a-accordion__editing-btn" type="button" @click="$emit('editItem', item)">
                      <img src="@/assets/img/static/b-icon_edit.svg">
                    </button>
                    <button class="a-accordion__remove-btn" type="button" @click="$emit('deleteItem', item)">
                      <img src="@/assets/img/static/trashcan.svg">
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from '@/validators'

  export default {
    props: {
      items: Array,
      isNew: Boolean
    },

    computed: {
      records() {
        return this.items;
      }
    },

    methods: {
      onConfirmClick(item) {
        if (!required(item.num)) {
          this.$set(item, 'error', true);
          return;
        }

        this.$set(item, 'error', false);
        this.$emit('confirmEditable', item);
      },

      onCancelClick(item) {
        this.$emit('cancelEditable', item);
      }
    }
  }
</script>

<style scoped>

</style>
